// File: /Users/alex/PilotMode/GlobalCommand-Center/FrontStack/src/Pages/LandingPage/ModernCTASection.js

import React from "react";
import { Typography, Button, Box, Container } from "@mui/material";
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const ModernCTASection = ({ onGetStartedClick }) => {
  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #1f2937 0%, #111827 100%)",
        py: 10,
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ textAlign: "center" }}>
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "20px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 4,
              boxShadow: "0 16px 48px rgba(102, 126, 234, 0.4)",
            }}
          >
            <RocketLaunchIcon sx={{ fontSize: 48, color: "#fff" }} />
          </Box>
          <Typography
            variant="h3"
            sx={{
              color: "#fff",
              fontWeight: 800,
              mb: 3,
              fontSize: { xs: "2rem", md: "2.5rem" },
            }}
          >
            Ready to transform your workflow?
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: "rgba(255,255,255,0.8)",
              mb: 5,
              fontWeight: 400,
            }}
          >
            Join 325+ team members already using Orunal
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={onGetStartedClick}
            endIcon={<ArrowForwardIcon />}
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "#fff",
              px: 6,
              py: 2,
              fontSize: "18px",
              fontWeight: 700,
              borderRadius: "16px",
              textTransform: "none",
              boxShadow: "0 16px 48px rgba(102, 126, 234, 0.4)",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: "0 20px 56px rgba(102, 126, 234, 0.5)",
              },
              transition: "all 0.3s ease",
            }}
          >
            Start Your Free Trial
          </Button>
          <Typography
            variant="caption"
            sx={{
              display: "block",
              color: "rgba(255,255,255,0.6)",
              mt: 2,
            }}
          >
            No credit card required • Free 14-day trial • Cancel anytime
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default ModernCTASection;